import { render, staticRenderFns } from "./setMerchantCompanyRate.vue?vue&type=template&id=7651e005&scoped=true&"
import script from "./setMerchantCompanyRate.vue?vue&type=script&lang=js&"
export * from "./setMerchantCompanyRate.vue?vue&type=script&lang=js&"
import style0 from "./setMerchantCompanyRate.vue?vue&type=style&index=0&id=7651e005&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7651e005",
  null
  
)

export default component.exports